<template>
    <div id="app">
        <IndexNav></IndexNav>
    </div>
</template>
<script>
  import IndexNav from "./components/IndexNav";
  export default {
    name: 'App',
    components: {
      IndexNav
    }
  }
</script>
<style lang="scss">
    html, body {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        color: rgba(0,0,0,.85);
        font-size: 14px;
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
        background: #fff;
        -webkit-transition: background 1s cubic-bezier(.075,.82,.165,1);
        transition: background 1s cubic-bezier(.075,.82,.165,1);

        * {
            margin: 0;
            padding: 0;
        }

        #app {
            width: 100%;
            height: 100%;
        }
    }
</style>
